var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alert-light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.76,2.5h.75c1.41.29,2,2.45,2.81,4,3.73,7.86,7.32,15.61,11,23.53a20,20,0,0,1,1.69,4v1.1a2.86,2.86,0,0,1-2,2.33H5.92A2.71,2.71,0,0,1,4,35.29v-1.1a28.29,28.29,0,0,1,1.69-4c4-8.33,8-16.59,11.86-24.87C18.14,4,18.55,2.85,19.76,2.5Z",
    fill: "none",
    stroke: "#48b2e1",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.11,13.52c.22-.71,1.6-1.38,2.73-1.49a3.84,3.84,0,0,1,3.27,1.39h0s-.41,5.43-.68,8.54c-.13,1.72-.2,3.54-2.59,3.26C18,25,18,23.29,17.91,21.57",
    fill: "#48b2e1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.11,
    cy: 30.02,
    r: 3,
    fill: "#48b2e1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertLight);
export default __webpack_public_path__ + "static/media/alert-light.073737aa002f274d5f24289a05076946.svg";
export { ForwardRef as ReactComponent };